import { Children } from 'react';
const filter = (children, filterFn) => Children.toArray(children).filter(filterFn);
export default filter;
//# sourceMappingURL=filter.js.map